import React from 'react';
import { Globe, Smartphone, Layout, ArrowRight } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'WordPress Development',
    description: 'Custom, scalable, and secure WordPress solutions tailored to your business needs. We build easy-to-manage websites that perform.',
    icon: Globe
  }, {
    title: 'Web Design',
    description: 'Stunning, user-centric designs that capture your brand identity. We focus on UI/UX best practices to convert visitors into customers.',
    icon: Layout
  }, {
    title: 'Mobile Apps',
    description: 'Native and hybrid mobile applications for iOS and Android. From concept to launch, we deliver seamless mobile experiences.',
    icon: Smartphone
  }];
  return <section id="services" className="py-24 bg-gray-50" data-id="element-145">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-146">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-147">
          <h2 className="text-base font-semibold text-blue-600 tracking-wide uppercase mb-2" data-id="element-148">
            What We Do
          </h2>
          <p className="text-3xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-149">
            Comprehensive Digital Services
          </p>
          <p className="text-lg text-gray-600" data-id="element-150">
            We combine technical expertise with creative innovation to deliver
            solutions that help your business grow.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12" data-id="element-151">
          {services.map((service, index) => <div key={index} className="bg-white rounded-xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300 flex flex-col h-full group" data-id="element-152">
              <div className="w-14 h-14 bg-navy-50 rounded-lg flex items-center justify-center mb-6 group-hover:bg-navy-900 transition-colors duration-300" data-id="element-153">
                <service.icon className="h-7 w-7 text-navy-900 group-hover:text-white transition-colors duration-300" data-id="element-154" />
              </div>

              <h3 className="text-xl font-bold text-navy-900 mb-4" data-id="element-155">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-8 flex-grow leading-relaxed" data-id="element-156">
                {service.description}
              </p>

              <a href="#contact" className="inline-flex items-center text-blue-600 font-semibold hover:text-blue-700 transition-colors" data-id="element-157">
                Learn More
                <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-158" />
              </a>
            </div>)}
        </div>
      </div>
    </section>;
}